import { HelpersModule } from "../helpers/helpers";

const helpersModule = new HelpersModule();

export class ConsultantSearchFormModule {

    constructor() {
        this.init();
    }

    ConsultantSearchFormClicks() {
        $(".js-consultant-search-form-submit").on('click', function (e) {
            e.preventDefault();

            var $form = $("#consultantSearchForm"),
                filterConsultantType = $form.find("input:radio[name=filterConsultantType]:checked").val(),
                filterTreatmentSpeciality = $form.find("#treatmentSpecialitySearch").val(), // Might need to tell results page if speciality or treatment
                filterLocation = $form.find("#location-finder").val(),
                filterName = $form.find("#nameSearch").val(),
                filterByBookable = $form.find("#filterByBookable").val(),
                url = $form.attr("action");

            url += "?filterConsultantType=" + filterConsultantType + "&filterTreatmentSpeciality=" + filterTreatmentSpeciality
                + "&filterLocation=" + filterLocation + "&filterName=" + filterName + "&filterByBookable=" + filterByBookable;

            window.location.assign(url);

        });
    }

    init() {

        this.ConsultantSearchFormClicks();

    }

}